import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import invariant from "tiny-invariant";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Modal,
  Paper,
  useTheme,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import { TreeContext } from "../tree-context";
import useStyles from "./styles";
import { TreeItem } from "../../data/tree";
import { Socket } from "socket.io-client";
import { useNotification } from "../../../../notificationProvider";

type FormData = {
  parent: string;
  position: number;
};

export function MoveModal({
  onClose,
  itemId,
  item,
  open,
  socket,
}: {
  onClose: () => void;
  item: TreeItem;
  itemId: string;
  open: boolean;
  socket: Socket;
}) {
  const {
    dispatch,
    getChildrenOfItem,
    getMoveTargets,
    getParentsMoveTargets,
    getPathToItem,
  } = useContext(TreeContext);
  const theme = useTheme();
  const styles = useStyles(theme);
  const notify = useNotification();
  const options = useMemo(() => {
    const targets = getMoveTargets({ itemId });
    const teste = getParentsMoveTargets({ itemId });
    // console.log("teste", teste);
    const targetOptions = targets.map((item) => ({
      label: `${item.title}`,
      value: item.id,
    }));
    // console.log("options", targets);
    return [{ label: "Sem página pai", value: "" }, ...targetOptions];
  }, [getMoveTargets, itemId]);

  const defaultParent = useMemo(() => {
    const path = getPathToItem(itemId);
    const parentId = path[path.length - 1] ?? "";
    const option = options.find((option) => option.value === parentId);
    // invariant(option);
    if (!option) {
      return "";
    }

    return option.value;
  }, [getPathToItem, itemId, options]);

  const [parentId, setParentId] = useState(defaultParent);
  const positionOptions = useMemo(() => {
    const targets = getChildrenOfItem(parentId).filter(
      (item) => item.id !== itemId
    );
    return Array.from({ length: targets.length + 1 }, (_, index) => ({
      label: String(index + 1),
      value: index + 1,
    }));
  }, [getChildrenOfItem, itemId, parentId]);

  const [position, setPosition] = useState(1);

  useEffect(() => {
    setPosition(1);
  }, [parentId, positionOptions.length]);
  async function handlSocketUpdatePosition(id: string, parentId: string) {
    let data = { id, parentId };
    let response = null;
    try {
      socket.emit("updatePositionPages", data, (res: any) => {
        // console.log("Response from socket:", res);

        if (res.status === 201) {
          notify(null, "Elemento atualizado com sucesso!", "success");
          dispatch({
            type: "modal-move",
            itemId,
            targetId: parentId,
            // index: positionOptions.length,
          });
          onClose();

          response = res.data;
        } else {
          notify(null, "Não foi possível atualizar o elemento", "error");
        }
      });
      return response;
    } catch (error: any) {
      if (error.code && !error.response) {
        notify(error.code, error.message, "error");
      } else {
        notify(error.status, error?.response?.data.message, "error");
      }
      console.error(error);
    } finally {
      // setCheckChanges(false);
    }
  }
  const onSubmit = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();
      const data = await handlSocketUpdatePosition(itemId, parentId);
    },
    [dispatch, itemId, parentId, position, onClose]
  );

  return (
    <Modal open={open} closeAfterTransition onClose={onClose} sx={styles.modal}>
      <Paper sx={styles.paper}>
        <form onSubmit={onSubmit}>
          <Box sx={styles.boxHeader}>
            <Typography variant="h6">
              Mover<i> "{item.title}"</i>
            </Typography>
          </Box>
          <Box sx={styles.boxContent}>
            <Autocomplete
              disablePortal
              options={options}
              getOptionLabel={(option) => option.label}
              value={options.find((option) => option.value === parentId)}
              onChange={(event, newValue) => {
                setParentId(newValue?.value || "");
              }}
              renderInput={(params) => (
                <TextField {...params} label="Pai" variant="filled" />
              )}
            />
            {/* <Autocomplete
              disablePortal
              options={positionOptions}
              getOptionLabel={(option) => option.label}
              value={positionOptions.find(
                (option) => option.value === position
              )}
              onChange={(event, newValue) => {
                setPosition(newValue?.value || 1);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Posição" variant="filled" />
              )}
            /> */}
          </Box>
          <Box sx={styles.boxActions}>
            <Button onClick={onClose} variant="outlined">
              Cancelar
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Mover
            </Button>
          </Box>
        </form>
      </Paper>
    </Modal>
  );
}
